import React from "react";
import PartnersPageBox from "../components/PartnersPageBox";
import "primeflex/primeflex.css";
export default function PartnersPage() {
  return (
    <div>
      <PartnersPageBox />
    </div>
  );
}
